export const ApiPaths = {
  // staff: "/business-staff",
  staff: "/keycloak/user",
  staffStatistics: "/keycloak/userStatistics",
  products: "/product",
  cart: "/cart",
  claims: "/claimList",
  claimsStatistics: "/statistics/claims",
  covers: "/coverList",
  coversStatistics: "/statistics/covers",
  dashboard: "/dashboard",
  notifications: "/notifications",
  claimStatus: "/claims-status",
  coverStatus: "/cover-status",
  currency: "/currency",
  wallets: "/wallet",
  sumsubStatus: "/sumsub/verification-statuses",
  sumsubToken: "/sumsub/applicants",
  register: "/registration-request",
  user: "/auth/user-details",
  profilePicture: `/admin/profilePicture/update`,
  loginUser: "/auth/token",
  kycInfo: "/auth/kyc-info",
  loginUserTest: "/test/token",
  premium: "/premium",
};
